import React, { useState } from "react";
import "../index.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { APIURL } from "../../../Config";
import { toast } from "react-toastify";

function TalkToSales() {
  const [isLoader, setIsLoader] = useState(false);
  const corporateId = localStorage.getItem("corporateId");
  const token = localStorage.getItem("token");
  const emailId = localStorage.getItem("corpadminmail");
  const LoginSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("required")
      .min(10, "MobileNo must be 10 characters at minimum"),
    empname: Yup.string().required("required"),
    corporateName: Yup.string().required("required"),
    noofemployees: Yup.string().required("required"),
    designation: Yup.string().required("required"),
    emailId: Yup.string().email("Invalid email format").required("required"),
  });
  return (
    <div className="pt-3">
      <div className="card">
        <div className="p-4">
          {" "}
          <Formik
            initialValues={{
              empname: "",
              emailId: "",
              designation: "",
              corporateName: "",
              noofemployees: "",
              mobile: "",
            }}
            validationSchema={LoginSchema}
            onSubmit={(values, { resetForm }) => {
              let dto = {
                ...values,
                emailId: emailId,
                corporateId: corporateId,
              };

              setIsLoader(true);
              axios
                .request(`${APIURL}/corporate/talktosales`, {
                  method: "POST",
                  data: dto,
                  headers: {
                    Authentication: token,
                    "Content-Type": "application/json",
                  },
                })
                .then((response) => {
                  console.log("response:::", response);
                  setIsLoader(false);
                  toast.success("Successfully...");
                  resetForm();
                })
                .catch((error) => {
                  console.log("error", error);
                  setIsLoader(false);
                  toast.warning("User does not exist...");
                  resetForm();
                });
            }}
          >
            {({ touched, errors }) => (
              <>
                <Form className="">
                  <div>
                    <div>
                      <h4
                        className="py-2 text-center"
                        style={{ color: "#66a725", fontWeight: 800 }}
                      >
                        Talk to Sales
                      </h4>
                    </div>
                    <div className="">
                      <label>Work Email*</label>
                      <Field
                        type="email"
                        name="emailId"
                        placeholder="Enter Work Email"
                        className={`form-control
                      ${touched.emailId && errors.emailId ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage
                        component="div"
                        name="emailId"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="mt-2">
                      <label>Company Name*</label>
                      <Field
                        type="text"
                        name="corporateName"
                        placeholder="Enter Company Name"
                        className={`form-control
                      ${
                        touched.corporateName && errors.corporateName
                          ? "is-invalid"
                          : ""
                      }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="corporateName"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="mt-2">
                      <label>Your Name*</label>
                      <Field
                        type="text"
                        name="empname"
                        placeholder="Enter Name"
                        className={`form-control
                      ${touched.empname && errors.empname ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage
                        component="div"
                        name="empname"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="mt-2">
                      <label>Designation*</label>
                      <Field
                        type="text"
                        name="designation"
                        placeholder="Enter Designation"
                        className={`form-control
                      ${
                        touched.designation && errors.designation
                          ? "is-invalid"
                          : ""
                      }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="designation"
                        className="invalid-feedback"
                      />

                      <div className="mt-2">
                        <label>Mobile No*</label>
                        <Field
                          type="number"
                          name="mobile"
                          placeholder="Enter Mobile No"
                          className={`form-control
                      ${touched.mobile && errors.mobile ? "is-invalid" : ""}`}
                        />
                        <ErrorMessage
                          component="div"
                          name="mobile"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="mt-2">
                        <label>No. of employees*</label>
                        <Field
                          type="number"
                          name="noofemployees"
                          placeholder="Enter no. of employees"
                          className={`form-control
                      ${
                        touched.noofemployees && errors.noofemployees
                          ? "is-invalid"
                          : ""
                      }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="noofemployees"
                          className="invalid-feedback"
                        />
                      </div>

                      <button
                        className="btn btn-success mt-3 border"
                        type="submit"
                        style={{ backgroundColor: "#66a725" }}
                      >
                        {isLoader ? (
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                      {/* <hr /> */}
                    </div>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default TalkToSales;
